import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom'; 
import axiosClient, { postData, getData } from '../global/Globalapi';
import { FaHeart, FaBoxOpen } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { IoArrowBackOutline } from 'react-icons/io5';
import CartSuccessPopup from '../Cart/CartSuccessPopup';

const WishproductsCards = () => {
    const { id } = useParams();
    const [products, setProducts] = useState([]);
    const [mainImage, setMainImage] = useState('');
    const baseURL = axiosClient.defaults.baseURL;

    const [carrtpopup, setcartpopup] = useState(false);
    const [prod, setprod] = useState({});
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false); 
    const [pendingAddToCart, setPendingAddToCart] = useState(false); 
    const [user, setUser] = useState(null); 
   const handleRedirect = (productId) => {
    const encodedId = btoa(productId.toString());
    navigate(`/product/${encodedId}`);
  };
    const getUserId = (localUser = null) => {
        try {
            const userString = localStorage.getItem("user");
            if (localUser) {
                return localUser.user_id;
            }
            if (userString) {
                const user = JSON.parse(userString);
                return user.user_id;
            }
            return null;
        } catch (error) {
            console.error("Failed to parse user data from localStorage:", error);
            return null;
        }
    };

    // ✅ FIXED: Changed to use GET endpoint
    useEffect(() => {
        const fetchWishlist = async () => {
            try {
                const user_id = getUserId();
                if (!user_id) {
                    console.log("No user ID found.");
                    return;
                }

                // ✅ Changed from postData to getData with URL parameter
                const res = await getData(`/wishlist/${user_id}`);

                if (res.status === 200) {
                    const data = res.data.data;
                    setProducts(data);
                    if (data.length > 0) {
                        setMainImage(`${baseURL}/uploads/${data[0].file_name}`);
                    }
                }
            } catch (err) {
                console.error("Failed to fetch wishlist:", err);
            }
        };

        fetchWishlist();
    }, [id, baseURL]); 

    useEffect(() => {
        if (user && pendingAddToCart) {
            console.log("Login successful; completing pending Add to Cart action.");
            setPendingAddToCart(false); 
        }
    }, [user, pendingAddToCart]);

    if (!products || products.length === 0) {
        return (
            <div className='w-full min-h-screen p-6 flex flex-col items-center justify-center'>
                <div className='flex flex-col items-center justify-center border-4 border-dashed border-gray-300 rounded-2xl p-10 bg-gradient-to-tr from-yellow-50 via-purple-50 to-cyan-50 shadow-lg'>
                    <p className="text-center p-8 text-[#ffa600] text-4xl font-bold">No products in wishlist.</p>
                    <FaBoxOpen className="text-[#ffa600] text-9xl " />
                    <button 
                        className="mt-4 px-6 py-2 bg-[#c97c5d] text-white rounded-lg hover:shadow-xl hover:scale-105 transition duration-300"
                        onClick={() => navigate('/')}>
                        Continue Shopping
                    </button>
                </div>
            </div>
        );
    }

    const handleRemoval = async (product_id) => {
        const user_id = getUserId();
        if (!user_id) {
            console.log("No user ID found for removal.");
            return;
        }

        try {
            const res = await postData("/update-wish", { user_id, product_id });

            if (res.status === 200 || res.data.success) {
                toast.success(res.data.message || "Product removed from wishlist.");
                const updatedProducts = products.filter(
                    (product) => product.product_id !== product_id
                );
                setProducts(updatedProducts);
                if (updatedProducts.length === 0) {
                    setMainImage('');
                }
            } else {
                toast.error("Failed to remove product.");
            }
        } catch (error) {
            console.error("Error during product removal:", error);
            toast.error("An error occurred during removal.");
        }
    }

    const renderStars = (rating) => {
        const validRating = !isNaN(rating) && rating > 0 ? Math.round(rating) : 0;
        return (
            <div className="text-yellow-400 text-base mt-1">
                {'★'.repeat(validRating)}{'☆'.repeat(5 - validRating)}
            </div>
        );
    };
    
    const onContinueShopping = () => {
        setcartpopup(false);
    }

    const onGoToCart = () => {
        navigate('/cart');
        setcartpopup(false);
    }

    const onBuyNow = async () => {
        navigate("/checkout");
        setcartpopup(false);
    }

    const handleaddtocart = async (product) => {
        const userId = getUserId();

        if (!userId) {
            setprod(product); 
            setIsModalOpen(true);
            setPendingAddToCart(true); 
            toast.info("Please log in to add items to your cart.");
            return;
        }

        setPendingAddToCart(false);
        setprod(product); 

        const newcartitem = {
            user_id: userId,
            childid: null, 
            parentid: Number(product.product_id),
            image_url: `${baseURL}/uploads/${product.file_name}`,
            product_name: product.product_name,
            amount: product.net_price_rtl, 
            options: {} 
        };
        
        try {
            const res = await postData("/cart", newcartitem);
            if (res.status === 200) {
                setprod(newcartitem); 
                setcartpopup(true); 
            } else {
                toast.error(res.data.message || "Failed to add to cart");
            }
        } catch (error) {
            toast.error("Failed to add to cart");
            console.error("Cart API error:", error);
        }
    }
 const goToShopping = () => {
     navigate(-1);
    };
    return (
        <div className="w-full min-h-screen p-6 bg-gradient-to-tr from-yellow-50 via-purple-50 to-cyan-50">
            <>
                      <button
                        onClick={goToShopping}
                        className="mb-4 bg-[#c97c5d] hover:bg-orange-600 text-white font-semibold px-4 py-2 rounded-lg">
                      <IoArrowBackOutline className="text-2xl" />
                      </button>
                  </>
            {carrtpopup && (
                <CartSuccessPopup
                    product={prod} 
                    onContinueShopping={onContinueShopping}
                    onGoToCart={onGoToCart}
                    onBuyNow={onBuyNow}
                />
            )}

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-8">
                {products.map((product) => {
                    const imageUrl = `${baseURL}/uploads/${product.file_name}`;
                    const isLowStock = product.initial_stock <= 5;
                    return (
                        <div
                            key={product.product_id}
                            onClick={() => handleRedirect(product.product_id)}
                            className="relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-transform duration-300 ease-in-out transform hover:-translate-y-2 hover:scale-105 border border-gray-100 flex flex-col group"
                        >
                            {/* Heart Badge */}
                            <div className="absolute top-3 right-3 z-10">
                                <FaHeart className="text-pink-400 drop-shadow-lg text-xl bg-white rounded-full p-1 shadow-md transition-transform group-hover:scale-125" />
                            </div>

                            {/* Product Image */}
                            <div className="flex justify-center items-center h-48 bg-gray-50 rounded-t-2xl overflow-hidden shadow-inner">
                                <img
                                    src={imageUrl}
                                    alt={product.product_name}
                                    className="h-full w-auto max-w-full object-contain transition-transform duration-300 group-hover:scale-110 cursor-pointer"
                                    onClick={() => setMainImage(imageUrl)}
                                />
                            </div>

                            {/* Product Info */}
                            <div className="p-4 flex flex-col flex-1">
                                <h2 className="text-lg font-bold mb-1 line-clamp-2 text-gray-900">
                                    {product.product_name}
                                </h2>
                                <p className="text-gray-600 mb-1">
                                    MRP: <span className="font-semibold text-gray-800">
                                        {/* ₹{product.unit_selling_price} */}
                                         ₹{Number(product.unit_selling_price).toFixed(2)}
                                    </span>
                                </p>

                                {/* Show stock status only if low */}
                                {isLowStock && (
                                    <p className="text-red-600 mb-2 font-semibold">
                                        {/* Stock: <span className="uppercase">Low</span> */}
                                    </p>
                                )}

                                {/* ✅ FIXED: Added safe rating calculation */}
                                {product.user_rating_no > 0 && renderStars(product.star_ratings / product.user_rating_no)}

                                <hr className="border-gray-100 my-2" />

                                <div className="flex gap-2 mt-auto">
                                    <button
                                        className="flex-1 bg-orange-400 hover:bg-orange-500 transition-colors font-semibold px-4 py-2 rounded-xl shadow hover:scale-105 focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:ring-offset-2"
                                        onClick={() => handleaddtocart(product)}
                                    >
                                       View
                                    </button>
                                    <button
                                        className="flex-1 bg-gray-200 hover:bg-red-200 text-gray-600 transition-colors px-3 py-2 rounded-xl shadow hover:scale-105 focus:outline-none"
                                        onClick={() => handleRemoval(product.product_id)}
                                    >
                                        Remove
                                    </button>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default WishproductsCards;